import { render, staticRenderFns } from "./OpenSignUpJobButton.vue?vue&type=template&id=d545c754&"
import script from "./OpenSignUpJobButton.vue?vue&type=script&lang=js&"
export * from "./OpenSignUpJobButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports